import React from "react";
import FooterContainer from "./Footer.css";
import Image from "../../assets/image/image";
const Footer = () => {
  return (
    <FooterContainer>
      <div className="Banner">
        <div className="BannerImg">
          <ul>
            <li>
              <a
                href="https://www.mss.go.kr/site/smba/main.do"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Image.ventrue} alt="중소벤처기업부" />
              </a>
            </li>
            <li>
              <a
                href="https://www.acrc.go.kr/acrc/index.do"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Image.interests} alt="국민권익위원회" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="Content">
        <div className="ContentImg">
          <img src={Image.logo} alt="logo"></img>
        </div>
        <table className="ContentAddress">
          <tbody>
            <tr>
              <td>
                <b>상호 : </b>
                <span>(사)한국창조경영인협회</span>
              </td>
              <td colSpan="2">
                <b>주소 : </b>
                <span>서울 양천구 목동 923-14 현대드림타워 1718호</span>
              </td>
            </tr>
            <tr>
              <td>
                <b>전화 : </b>
                <span>02-2647-1800</span>
              </td>
              <td>
                <b>팩스 : </b>
                <span>02-2647-1811</span>
              </td>
              <td>
                <b>이메일 : </b>
                <span>mir3768@naver.com</span>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <p>
                  Copyrights @ KOREA TALENT SAHERE-MANAGEMENT ASSOCIATION. ALL
                  RIGHTS RESERVED.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </FooterContainer>
  );
};

export default Footer;
